import { render } from "./Versions.vue?vue&type=template&id=9a7da188&scoped=true&ts=true"
import script from "./Versions.vue?vue&type=script&lang=ts"
export * from "./Versions.vue?vue&type=script&lang=ts"

import "./Versions.vue?vue&type=style&index=0&id=9a7da188&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7da188"]])

export default __exports__